module.exports = __webpack_public_path__ + "static/media/23.51ac6f46.jpg";